import type {ChildDefs} from './types';

export const PARENT_TO_CHILD_TYPE =
  'stripe-third-party-parent-to-child' as const;
export const CHILD_TO_PARENT_TYPE =
  'stripe-third-party-child-to-parent' as const;
export const READY_TYPE = 'stripe-third-party-frame-ready' as const;
export const ERROR_TYPE = 'stripe-third-party-frame-error' as const;
export const CHILD_DEFINITIONS: ChildDefs = {
  DemoPayButton: {path: 'DemoPayButton.html'},
  AddressAutocomplete: {path: 'AddressAutocomplete.html'},
  AffirmInContext: {path: 'AffirmInContext.html'},
  AmazonPayButton: {path: 'AmazonPayButton.html'},
  AuthMap: {path: 'AuthMap.html'},
  DynamicMap: {path: 'DynamicMap.html'},
  GoogleAnalytics: {path: 'GoogleAnalytics.html'},
  GoogleTagManager: {path: 'GoogleTagManager.html'},
  GoogleMaps: {path: 'GoogleMaps.html'},
  GoogleAPI: {path: 'GoogleAPI.html'},
  GooglePay: {path: 'GooglePay.html'},
  HCaptcha: {path: 'HCaptcha.html'},
  HCaptchaInvisible: {path: 'HCaptchaInvisible.html'},
  HomeFeedItemPreview: {path: 'HomeFeedItemPreview.html'},
  Iovation: {path: 'iovation.html'},
  MetaPay: {path: 'MetaPay.html'},
  RLogger: {path: 'RLogger.html'},
  Sprig: {path: 'Sprig.html'},
  StaticMap: {path: 'StaticMap.html'},
  StatusSite: {path: 'StatusSite.html'},
  StripeJsV3: {path: 'StripeJsV3.html'},
  Twilio: {path: 'Twilio.html'},
  TwilioVoice: {path: 'TwilioVoice.html'},
  TwitterEmbed: {path: 'TwitterEmbed.html'},
  YouTubePlayer: {path: 'YouTubePlayer.html'},
  PaypalECS: {path: 'PaypalECS.html'},
  PaypalFraudnet: {path: 'PaypalFraudnet.html'},
};
